<script setup lang="ts">
import { inject, type ComputedRef } from 'vue';
import SettingChildProfileView from './SettingChildProfileView/SettingChildProfileView.vue';
import SettingParentProfileView from './SettingParentProfileView/SettingParentProfileView.vue';
import { useCurrentUser } from 'shared/composables/useCurrentUser';
import SettingLanguageCard from 'modules/Setting/components/SettingLanguageCard/SettingLanguageCard.vue';
import SettingAppearanceCard from 'modules/Setting/components/SettingAppearanceCard/SettingAppearanceCard.vue';
import SettingLicenseCard from 'modules/Setting/components/SettingLicenseCard/SettingLicenseCard.vue';
import SettingClearStorageCard from 'modules/Setting/components/SettingClearStorageCard/SettingClearStorageCard.vue';

const currentUserId = inject('currentUserId') as ComputedRef<number>;
const currentUser = useCurrentUser(currentUserId.value, 'all');
</script>

<template>
  <div
    v-if="currentUser"
    class="row q-col-gutter-md"
  >
    <div
      v-if="currentUser?.role?.type !== 'child'"
      class="col-12 col-sm-6 flex"
    >
      <SettingParentProfileView class="full-width" />
    </div>
    <div
      v-if="currentUser?.role?.type === 'child'"
      class="col-12 col-sm-6 flex"
    >
      <SettingChildProfileView class="full-width" />
    </div>
    <div class="col-12 col-sm-6 flex">
      <SettingLanguageCard class="full-width" />
    </div>
    <div class="col-12 col-sm-6 flex">
      <SettingAppearanceCard class="full-width" />
    </div>
    <div
      v-if="currentUser?.role?.type === 'child'"
      class="col-12 col-sm-6 flex"
    >
      <SettingLicenseCard
        :current-user="currentUser"
        class="full-width"
      />
    </div>
    <div class="col-12 col-sm-6 flex">
      <SettingClearStorageCard
        :current-user="currentUser"
        class="full-width"
      />
    </div>
  </div>
</template>
